"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var loginBaseTheme = function (_breakpoints) {
    return ({
        login: {
            flex: "1",
            alignItems: "center",
            flexDirection: "column",
            display: "flex",
            paddingTop: "3rem"
        },
        loginMessageWrapper: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
        },
        loginMessage: {
            fontSize: "1.5rem"
        },
        loginEndpointWrapper: {
            fontSize: "1.5rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
        },
        loginEndpointLink: {
            padding: "1rem",
            border: "2px rgba(0,0,0,0.24) solid",
            borderRadius: "2px",
        }
    });
};
exports.default = loginBaseTheme;
//# sourceMappingURL=login.js.map